import { Palette } from '@infoods/lifebase-ui';
import { Plugin } from 'chart.js';
import {
  drawDashLine,
  drawPoint,
  getChartBorder,
} from '../../../../../shared/features/charts';

export const getGraphPlugins = (palette: Palette): Plugin[] => [
  getChartBorder(palette),
  {
    id: 'hover',
    beforeTooltipDraw(chart, args) {
      const { ctx, chartArea } = chart;
      const { tooltip } = args;

      if (!tooltip.dataPoints || tooltip.dataPoints.length === 0) {
        return;
      }

      const dataIndex = tooltip.dataPoints[0].dataIndex;
      const pointX = tooltip.caretX;

      const currentPointY = chart.getDatasetMeta(0).data[dataIndex]?.y;

      if (currentPointY) {
        drawDashLine(
          ctx,
          chartArea,
          { pointX, pointY: currentPointY, gapFromStart: 6 },
          palette.success[400],
        );
      }

      if (currentPointY) {
        drawPoint(
          ctx,
          { pointX, pointY: currentPointY, strokeColor: palette.success[500] },
          palette,
        );
      }

      const previousPointY = chart.getDatasetMeta(1).data[dataIndex]?.y;

      if (previousPointY) {
        drawPoint(
          ctx,
          { pointX, pointY: previousPointY, strokeColor: palette.neutral[400] },
          palette,
        );
      }
    },
  },
];
